import React, { Component } from "react";

const years = [
  2010,
  2011,
  2012,
  2013,
  2014,
  2015,
  2016,
  2017,
  2018,
  2019,
  2020
];
class Selection extends Component {
  render() {
    return (
      <>
        <div className="container text-center">
          <div className='rangeSelector'>
            <label className="m-1">From</label>
            <select
              className=" m-1 form-control"
              name="yearFrom"
              value={this.props.yearFrom}
              onChange={this.props.onChangeYear}
            >
              {years.map(y => {
                return (
                  <option key={y} value={y}>
                    {y}
                  </option>
                );
              })}
            </select>
            <label className="m-1">to</label>
            <select
              className="listbox-area m-1 form-control"
              name="yearTo"
              value={this.props.yearTo}
              onChange={this.props.onChangeYear}
            >
              {years.map(y => {
                return (
                  <option key={y} value={y}>
                    {y}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </>
    );
  }
}

export default Selection;
